import { MessageInterface } from "../interfaces/Message.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_MESSAGE: MessageInterface = {
  created_at: "",
  updated_at: "",
  deleted_at: null,
  shortMessage: "NORMAL",
  description: "",
  keys: [],
  message_type: {
    created_at: "",
    updated_at: "",
    deleted_at: null,
    name: "CONTROL",
    id: 0,
  },
  messageTypeId: 0,
  enumId: null,
  id: "",
  position: true,
  custom_keys: [],
  controller_info_msg_data: [],
  // ******************
  escalator_controller_info_message_type: null,
  elevator_controller_info_message_type: null,
  escalator_status_message_type: null,
  elevator_status_message_type: null,
  deviceType: "ELEVATOR",
  messageContentType: 2,
  debounce_time: null,
};
